var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61642 2.26411C1.78729 1.9812 2.72872 0.952167 3.40053 0.983232C3.60136 0.999874 3.77888 1.12136 3.92312 1.26226C4.25431 1.58567 5.20239 2.80886 5.2562 3.06625C5.38713 3.69754 4.63487 4.06144 4.8651 4.69772C5.45204 6.13392 6.46336 7.1452 7.90019 7.73155C8.53595 7.96176 8.89987 7.20955 9.53119 7.34102C9.78804 7.39483 11.0118 8.34286 11.3353 8.67404C11.4756 8.81771 11.5977 8.99578 11.6143 9.19659C11.6393 9.90388 10.5464 10.8586 10.3334 10.9806C9.83076 11.3401 9.17503 11.334 8.37562 10.9623C6.14493 10.0342 2.58004 6.53666 1.63473 4.22176C1.27303 3.42683 1.24806 2.7667 1.61642 2.26411Z",
    stroke: "#2FCDFF",
    strokeWidth: 0.81025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalls);
export default __webpack_public_path__ + "static/media/Calls.266491258f9465e0d93a2f2fc0e8e1b3.svg";
export { ForwardRef as ReactComponent };